import { render, staticRenderFns } from "./vehicleMaintenance_page.vue?vue&type=template&id=5168faaa&scoped=true"
import script from "./vehicleMaintenance_page.vue?vue&type=script&lang=js"
export * from "./vehicleMaintenance_page.vue?vue&type=script&lang=js"
import style0 from "./vehicleMaintenance_page.vue?vue&type=style&index=0&id=5168faaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168faaa",
  null
  
)

export default component.exports